import { render } from "./Dietitian.vue?vue&type=template&id=d6cb22e4&scoped=true"
import script from "./Dietitian.vue?vue&type=script&lang=ts"
export * from "./Dietitian.vue?vue&type=script&lang=ts"

import "./Dietitian.vue?vue&type=style&index=0&id=d6cb22e4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d6cb22e4"

export default script